import { Button, Typography } from '@/components/common';
import InputPassword from '@/components/form/input-password/input-password';

import AppRoutes from '@/const/routes';
import React from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { passwordCriteria } from '@/const';
import { useNotification } from '@/hooks';
import { authService } from '@/api';
import { useRouter } from 'next/router';
import { AuthLayout } from '@/components/layout/layout/AuthLayout';
import { ResetCard } from '@/components/auth/ResetCard';

export const ReactivateAccountPasswordScreen = () => {
	const router = useRouter();
	const { toastSuccess, toastError } = useNotification();
	const [isLoading] = React.useState<boolean>(false);
	const { code } = router.query;

	const rules = {
		password: {
			required: {
				value: true,
				message: 'This is required.',
			},
		},
		password_confirm: {
			required: {
				value: true,
				message: 'This is required.',
			},
			validate: (value: string) =>
				value === watch('password') ||
				'The passwords do not match. Please ensure they are identical.',
		},
	};

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors, isDirty, isValid },
	} = useForm({ mode: 'onChange' });

	const handleSubmitDataForm = async (values: FieldValues): Promise<void> => {
		try {
			const response = await authService.confirmRecoverAccount(
				code as string,
				values.password
			);
			toastSuccess(response.data.message);
			router.push(AppRoutes.CLIENTAPP_AUTH_SIGN_IN);
		} catch (error: any) {
			toastError(error.message);
		}
	};

	const handleBack = () => {
		router.push(AppRoutes.CLIENTAPP_AUTH_SIGN_IN, undefined, { shallow: true });
	};

	return (
		<AuthLayout withCarrousel={false}>
			<ResetCard
				title={'Set Your Password'}
				srcImage={undefined}
				classNameTitle="!text-4xl lg:px-6"
				handleBack={handleBack}
			>
				<form
					onSubmit={handleSubmit(handleSubmitDataForm)}
					className="space-y-6 w-full"
				>
					<div>
						<InputPassword
							name="password"
							title="Password"
							validate={true}
							register={register}
							rules={rules.password}
							error={errors.password}
							className="mb-4"
						/>
						{!errors.password && (
							<Typography type="regular-12" className="text-opacity-black">
								{passwordCriteria}
							</Typography>
						)}
					</div>
					<InputPassword
						name="password_confirm"
						title="Confirm Password"
						validate={false}
						register={register}
						rules={rules.password_confirm}
						error={errors.password_confirm}
						className="mt-4 3xl:mt-6"
					/>
					<Button
						type="submit"
						size="full"
						decoration="primary"
						disabled={isLoading || !isDirty || !isValid}
						className="!w-[300px] !h-16 mx-auto"
					>
						Set Your Password
					</Button>
				</form>
			</ResetCard>
		</AuthLayout>
	);
};
